export const SET_COMMENTS_LIST_LOADING = 'SET_COMMENTS_LIST_LOADING';
export const SET_COMMENT_FORM = 'SET_COMMENT_FORM';
export const SET_COMMENTS_DATA = 'SET_COMPANY_LOADING';
export const RESET_COMMENT_FORM = 'RESET_COMMENT_FORM';
export const PUT_NEW_COMMENT = 'PUT_NEW_COMMENT';
export const UPDATE_COMMENT_IN_LIST = 'UPDATE_COMMENT_IN_LIST';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
